var _rect, _path, _path2, _path3, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrdersCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 13,
    height: 15,
    stroke: "#F7FFFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5L6 6L8 4",
    stroke: "#F7FFFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 9L6 10L8 8",
    stroke: "#F7FFFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 13L6 14L8 12",
    stroke: "#F7FFFB"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 5.5,
    x2: 13,
    y2: 5.5,
    stroke: "#F7FFFB"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 9.5,
    x2: 13,
    y2: 9.5,
    stroke: "#F7FFFB"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 13.5,
    x2: 13,
    y2: 13.5,
    stroke: "#F7FFFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersCreate);
export default __webpack_public_path__ + "static/media/orders_create.d532e73dec0e56184933ca8235a99483.svg";
export { ForwardRef as ReactComponent };